export default "__VITE_ASSET__CK0rQmPh__"